(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advanced-clinic-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('mbc-advanced');
  if(!root)return;
  var groups=[
  {
    "title": "Class IV Laser Therapy",
    "desc": "Choose a professional high-power laser therapy system.",
    "cat": "advanced",
    "options": [
      [
        "accoLazeo Laser Therapy Machine (Power:5 Watt) Class IV",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/acco-lazeo-class-4-laser-therapy-5watt.jpg?v=1784883958",
        "/products/acco-lazeo-laser-therapy-machine-power-5-watt-class-iv"
      ],
      [
        "Smart Laser Therapy Unit (Power: 10 Watt) Class IV",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/smart-laser.jpg?v=1743166915",
        "/products/smart-laser-therapy-unit-power-10-watt-class-iv"
      ],
      [
        "Laser Therapy Unit (Power:20 Watt) Class IV",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/LA06_1.jpg?v=1707732771",
        "/products/laser-therapy-unit-power-20-watt-class-iv"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Shockwave Therapy",
    "desc": "Choose a premium radial or focused shockwave therapy system.",
    "cat": "advanced",
    "options": [
      [
        "Pneumatic Shockwave Therapy Machine (10 Bar)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/shk04-penumatic-shockwave-4.jpg?v=1715339087",
        "/products/pneumatic-shockwave-therapy-machine-10-bar"
      ],
      [
        "Shockwave Therapy Machine (8 Bar) Floor Model",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/shk07-shockwave-therapy-machine-8-bar_1.jpg?v=1758619893",
        "/products/shockwave-therapy-machine-8-bar-floor-model"
      ],
      [
        "Focus Shockwave Therapy Machine - Advance Shockwave",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/sweed-focus-shockwave-therapy.jpg?v=1764417606",
        "/products/focus-shockwave-therapy-machine-advance-shockwave"
      ],
      [
        "Smart Tecar Therapy Machine with Shockwave therapy 2 in 1",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/smart-tecar-therapy-4.jpg?v=1754644820",
        "/products/smart-tecar-therapy-machine-with-shockwave-therapy-2-in-1"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Tecar Therapy",
    "desc": "Select a RET and CET radiofrequency therapy system.",
    "cat": "advanced",
    "options": [
      [
        "acco Tecar-S Tecar Therapy Machine with RET CET with JMD 448KHz",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/acco-tecar-s-tecar-therapy-machine-448k_1.jpg?v=1768900902",
        "/products/acco-tecar-s-tecar-therapy-machine-with-ret-cet-with-jmd-448khz"
      ],
      [
        "Smart Tecar Therapy Machine for Pain relief",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/tcr03-smart-tecar-2.jpg?v=1731930464",
        "/products/smart-tecar-therapy-machine-for-pain-relief"
      ],
      [
        "Tecar Therapy Machine with RET CET 448KHz -TRC04",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TCR04-tecar-therapy.jpg?v=1755175781",
        "/products/tecar-therapy-machine-with-ret-cet-448khz-trc04"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Advanced Combination Therapy",
    "desc": "Select an advanced multi-modality electrotherapy system.",
    "cat": "advanced",
    "options": [
      [
        "accoStimu Physiotherapy Electrotherapy Machine (Touch Screen) Imported",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/acco-stimu-physiotherapy-electrotherapy-imported_1.jpg?v=1762939036",
        "/products/accostimu-physiotherapy-electrotherapy-machine-touch-screen-imported"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Cryotherapy",
    "desc": "Choose cold compression, air cryotherapy or contrast therapy.",
    "cat": "advanced",
    "options": [
      [
        "CryoPush Pulse Cold Compression Therapy Machine",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/cryopush-cryotherapy-machine.jpg?v=1727698807",
        "/products/cryopush-pulse-cold-compression-therapy-machine"
      ],
      [
        "Dr. Cryo Air Cryotherapy Machine",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/dr-cryo-air-therapy.jpg?v=1748515164",
        "/products/dr-cryo-air-cryotherapy-machine"
      ],
      [
        "acco Contract Bath Unit (Hot and Cold Therapy Machine)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/HC13.jpg?v=1720261443",
        "/products/acco-contract-bath-unit-hot-and-cold-therapy-machine"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Pelvic Chair",
    "desc": "Choose an advanced non-invasive pelvic floor stimulation chair.",
    "cat": "advanced",
    "options": [
      [
        "EMS Pelvic Floor Muscle Stimulator for Men & Women",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/EMSP01-pelvic-floor-muscle-stimulator_5160e76d-70f0-4203-8715-b3549d2f5880.jpg?v=1787304237",
        "/products/ems-pelvic-floor-muscle-stimulator-for-men-women"
      ],
      [
        "Advance EMS Pelvic Floor Stimulator Chair for Men & Women",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AdvanceEMSPelvicFloorStimulatorChairforMen_Women.jpg?v=1789981950",
        "/products/advance-ems-pelvic-floor-stimulator-chair-for-men-women"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Magneto Therapy",
    "desc": "Select high-intensity magnetic stimulation technology.",
    "cat": "advanced",
    "options": [
      [
        "2 in 1 Magneto Therapy Machine with Laser",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/mag01-magneto-therapy-machine-0.jpg?v=1737617478",
        "/products/2-in-1-magneto-therapy-machine-with-infrared"
      ],
      [
        "Magneto Therapy Machine (Floor Model)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/mga01-magneto-therapy.jpg?v=1722691390",
        "/products/magneto-therapy-machine-floor-model"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Diathermy",
    "desc": "Choose an advanced deep-heating therapy system.",
    "cat": "advanced",
    "options": [
      [
        "Terahertz Wave Therapy Machine",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/THZ01-Terahertz-gyromagant-machine.jpg?v=1772714776",
        "/products/terahertz-wave-therapy-machine"
      ],
      [
        "acco Microwave Diathermy Machine (Indian, Floor Model)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MD02-microvave-diathermy.jpg?v=1758611932",
        "/products/acco-microwave-diathermy-machine-indian-floor-model"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Biofeedback",
    "desc": "Choose biofeedback, neuromuscular stimulation or foot-drop rehabilitation.",
    "cat": "advanced",
    "options": [
      [
        "Konmed Biofeedback Neuromuscular Stimulator KM580",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/km580-konmed-biofeedback-stimulator_3.jpg?v=1751270572",
        "/products/konmed-biofeedback-neuromuscular-stimulator-km580"
      ],
      [
        "EMG Biofeedback Nerve and Muscle Stimulator with Pelvic & Anal Probe KM560",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/KM560-emg-biofeedback.jpg?v=1728990801",
        "/products/emg-biofeedback-nerve-and-muscle-stimulator-km560b-with-pelvic-anal-probe"
      ],
      [
        "Foot Drop System G5 2001F",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/G5-FOOT-DROP-FES.jpg?v=1743591289",
        "/products/foot-drop-system-g5-2001f"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Chiropractic Beds",
    "desc": "Choose an advanced chiropractic and spinal decompression table.",
    "cat": "exercise",
    "options": [
      [
        "acco Robotic Chiropractic Bed with Spinal Decompression 4 Drop (Electrical)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CHI05-robotic-chiropractic-bed_2.jpg?v=1756110961",
        "/products/acco-robotic-chiropractic-bed-with-spinal-decompression-4-drop-electrical"
      ],
      [
        "acco Chiropractic Bed with Spinal Decompression 4 Drop (Electrical)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CHI-04-chiropractic-decompression-table.jpg?v=1756976169",
        "/products/acco-chiropractic-bed-with-spinal-decompression-4-drop-electrical"
      ],
      [
        "Imported Chiropractic Bed with Spinal Decompression",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CHI07-chiropractic-decompression-table.jpg?v=1756984857",
        "/products/imported-chiropractic-bed-with-spinal-decompression"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Hi-Low Treatment Tables",
    "desc": "Choose an electric hi-low treatment or Bobath table.",
    "cat": "furniture",
    "options": [
      [
        "acco High Low Treatment Couch  3 Section",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AMP-03TC06-High-low-treatment-couch-3section.jpg?v=1768907663",
        "/products/acco-treatment-couch-cum-examination-couch-3-section"
      ],
      [
        "acco Hi Low Bobath Table (Two Section)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TE30A-bobath-treatment-couch.jpg?v=1735817179",
        "/products/acco-hi-low-bobath-table-two-section"
      ],
      [
        "acco Hi Low Bobath Table (Single Section)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TE30-bobath-treatment-couch.jpg?v=1735813379",
        "/products/acco-hi-low-bobath-table-single-section"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Premium Exercise & Rehab",
    "desc": "Choose a key premium mobility and rehabilitation system.",
    "cat": "exercise",
    "options": [
      [
        "UN-Weighting Mobility Trainer",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/un-weight-mobilitytrainer-2.jpg?v=1705755472",
        "/products/un-weighting-mobility-trainer"
      ],
      [
        "acco Physiotherapy Suspension Frame with Metal couch",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/suspension-frame-metal-bed.jpg?v=1731505808",
        "/products/acco-physiotherapy-suspension-frame-with-metal-couch"
      ],
      [
        "acco High Low Tilt table Electrical (Dual Motor) - Electric",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/ex75b-hilow-tilt-table-physiotherapy.jpg?v=1768216546",
        "/products/acco-high-low-tilt-table-electrical-dual-motor"
      ],
      [
        "acco Parallel Walking Bar with Platform",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/EX81-parallel-walking-bar.jpg?v=1760175083",
        "/products/acco-parallel-walking-bar-with-platform"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  }
];
  var addons=[
  [
    "Portable Massage Table(Folding, Briefcase Type) 2Fold",
    "furniture",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/portable-massage-tabel-2fold.jpg?v=1687959023",
    "/products/portable-massage-tablefolding-briefcase-type-2fold"
  ],
  [
    "Physiotherapy Examination Treatment Couch (Metal)",
    "furniture",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MED.EXA.820349430_1690180070389.webp?v=1699595532",
    "/products/physiotherapy-examination-treatment-couch-metal"
  ],
  [
    "acco Wooden Examination Treatment Couch / Plinth",
    "furniture",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TrewatmentCouchWooden2Section.jpg?v=1689064944",
    "/products/wooden-examination-treatment-couch-plinth"
  ],
  [
    "acco Trolley For Electrotherapy 1 Shelve",
    "furniture",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/electrotherapy-trolley-1.jpg?v=1702382118",
    "/products/acco-trolley-for-electrotherapy-1-shelve"
  ],
  [
    "acco Z Trolley For Electrotherapy 3 Shelve (Heavy Duty)",
    "furniture",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TE21z-z-trolley.jpg?v=1712064759",
    "/products/acco-z-trolley-for-electrotherapy-3-shelve-heavy-duty"
  ],
  [
    "Imp Trolley For Physiotherapy Machine",
    "furniture",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AMP-03TE21-IMP1-imported-trolley-physiotherapy_6.jpg?v=1769170920",
    "/products/imp-trolley-for-physiotherapy-machine"
  ],
  [
    "Uni Gym - All in 1 Home Gym System",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/uni-gym-portable-home-gym.jpg?v=1779094067",
    "/products/uni-gym-all-in-1-home-gym-system"
  ],
  [
    "G8 Professional Vibration Body Massage & Slimming Machine",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/G8-vibrator-body-massager.jpg?v=1764060447",
    "/products/g8-professional-vibration-body-massage-slimming-machine"
  ],
  [
    "acco Tilt table Manual",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/tilt-table-3.jpg?v=1721646348",
    "/products/acco-tilt-table-manual"
  ],
  [
    "acco Parallel Walking Bar without Platform",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/EX83-parallel-walking-bar-without-plateform_0f86e755-f4a2-4c21-a46e-c36f2f8ad0b1.jpg?v=1760177485",
    "/products/acco-parallel-walking-bar-without-platform"
  ],
  [
    "acco Physiotherapy Wall Bar (Wooden)",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/wooden-wall-bar.jpg?v=1731585698",
    "/products/acco-physiotherapy-wall-bar-wooden"
  ],
  [
    "Blaze Pod Trainer Kit",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/blaze-pod-trainer-kit-7.jpg?v=1721473245",
    "/products/blaze-pod-trainer-kit"
  ],
  [
    "acco Patient Lifting Machine (Electric)",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/patient-lifter-3.jpg?v=1710508557",
    "/products/acco-patient-lifting-machine-electric"
  ],
  [
    "acco Chiropractic Drop Table (electrical) - 5 Drop",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AMP-03CHI03-hi-low-chiropractic-bed-5drop.jpg?v=1766666883",
    "/products/acco-chiropractic-drop-table-electrical-5-drop"
  ],
  [
    "Exoskeleton Rehabilitation Robot",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Exoskeleton-rehabilitation-robot.jpg?v=1767960796",
    "/products/exoskeleton-rehabilitation-robot"
  ],
  [
    "Bobo Pro 2.0 - Balance board physio training solution with app for remote support",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/bobo-pro-2.0.jpg?v=1721474781",
    "/products/bobo-pro-2-0-balance-board-physio-training-solution-with-app-for-remote-support"
  ],
  [
    "Ginha Electric Chiropractic Gun -1200N",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CHG-1200N-E.jpg?v=1703339227",
    "/products/ginha-electric-chiropractic-gun-1200n"
  ],
  [
    "Electric Mini Exercise Bike (for Hand and Legs) with Leg Support",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/electric-pedo-cycle.jpg?v=1697879532",
    "/products/electric-mini-exercise-bike-for-hand-and-legs-with-leg-support"
  ],
  [
    "Active Passive Trainer - Rehab Trainer",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/apt2000a-active-passive-trainer.jpg?v=1736498683",
    "/products/active-passive-trainer-rehab-trainer"
  ],
  [
    "Upright Air Bike Exercise Static Cycle  - with Movable Handle",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/air-bike-movable-handle.jpg?v=1733483192",
    "/products/upright-air-bike-exercise-static-cycle-with-movable-handle"
  ],
  [
    "Aqua Bags - Weighted water bags",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/aqua-water-bags-weight-bags_a59dbf41-da61-486e-b4e0-fe748a220fed.jpg?v=1777888901",
    "/products/aqua-bags-weighted-water-bags"
  ],
  [
    "acco Mulligan Belts for Physiotherapy - Size: Length:-8ft",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MulliganBelt.jpg?v=1687518305",
    "/products/acco-mulligan-belts-for-physiotherapy-size-length-8ft"
  ],
  [
    "Original Dynamic Tape (Printed, 5mtr x 5cm) - 4 Way Stretch",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/dynamic-tape-original-1.jpg?v=1726319251",
    "/products/dynamic-kinesiology-sports-tape-printed-5mtr-x-5cm-4-way-stretch"
  ],
  [
    "Foam Balance Pad",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/foam-balance-pad.jpg?v=1744802513",
    "/products/foam-balance-pad"
  ],
  [
    "Korean Hijama Vacuum Cupping Set (19 Cups)",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Korean-hijama-cupping.jpg?v=1732271857",
    "/products/korean-hijama-vacuum-cupping-set-19-cups"
  ],
  [
    "Imported IASTM TOOLS for physiotherapy -Graston tool",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/IASTM-imported-1.jpg?v=1707904543",
    "/products/imported-iastm-tools-for-physiotherapy-graston-tool"
  ],
  [
    "N-live Compression Boots 8.0 DVT Machine (Leg Attachment)",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/nlive-compression-boots.jpg?v=1737621087",
    "/products/n-live-compression-boots-8-0-dvt-machine-leg-attachment"
  ],
  [
    "Compression Therapy System 12 Chamber",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/doctor-life-professional-compression-therapy-system-1.jpg?v=1732533738",
    "/products/compression-therapy-system-12-chamber"
  ],
  [
    "Doctor Life Compression Therapy Machine (with Leg Attachment)",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/doctor-life-dvt-compression-sp3000.jpg?v=1727696268",
    "/products/doctor-life-compression-therapy-machine-with-leg-attachment"
  ],
  [
    "Power web Hand and finger exerciser Size 14\"",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/power-web-1.jpg?v=1685611596",
    "/products/power-web-hand-and-finger-exerciser-size-14"
  ],
  [
    "TheraBand Flex Bar (Resistance Bar)",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TherabandFlexbar-3.jpg?v=1697279507",
    "/products/theraband-flex-bar-resistance-bar"
  ],
  [
    "Imported Weight Cuff for Wrist & Ankle",
    "other",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/imported-weightcuff.jpg?v=1766043555",
    "/products/imported-weight-cuff-for-wrist-ankle"
  ]
];
  var products=root.querySelector('#mbc-products');
  var extraGrid=root.querySelector('#mbc-extra-grid');
  var summary=root.querySelector('#mbc-summary-list');
  var count=root.querySelector('#mbc-count');
  var hidden=root.querySelector('#mbc-selected-hidden');
  var other=root.querySelector('#mbc-other');
  var wa=root.querySelector('#mbc-whatsapp');
  var form=root.querySelector('#mbc-form');
  var currentFilter='all';
  function esc(value){return String(value||'').replace(/[&<>'"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]})}
  function clean(value){return String(value||'').replace(/[<>]/g,'').trim()}
  function renderProducts(){products.innerHTML=groups.map(function(group,index){var first=group.options[0];return '<article class="mbc-product" data-group="'+esc(group.title)+'" data-category="'+group.cat+'"><div class="mbc-media"><img src="'+first[1]+'" alt="'+esc(first[0])+'"></div><div class="mbc-copy"><h3>'+esc(group.title)+'</h3><p>'+esc(group.desc)+'</p><div class="mbc-model-box"><label for="mbc-model-'+index+'">Change model</label><select class="mbc-model" id="mbc-model-'+index+'">'+group.options.map(function(o){return '<option value="'+esc(o[0])+'" data-image="'+esc(o[1])+'" data-url="'+esc(o[2])+'">'+esc(o[0])+'</option>'}).join('')+'</select></div><a class="mbc-link" href="'+first[2]+'" target="_blank" rel="noopener">View selected product</a><div class="mbc-select-row"><label class="mbc-select-label"><input class="mbc-pick" type="checkbox" checked> Selected</label><select class="mbc-qty" aria-label="Quantity for '+esc(group.title)+'"><option>1</option><option>2</option><option>3</option></select></div></div></article>'}).join('')}
  function selectedCoreNames(){return [].slice.call(root.querySelectorAll('.mbc-product')).filter(function(card){return card.querySelector('.mbc-pick').checked}).map(function(card){return card.querySelector('.mbc-model').value})}
  function renderExtras(){var selected=selectedCoreNames();var items=[];var seen={};groups.forEach(function(group){group.options.forEach(function(o){if(o[0]!=='Sales Person Recommendation'&&selected.indexOf(o[0])===-1&&!seen[o[0]]){items.push([o[0],group.cat,o[1],o[2],'Core alternative']);seen[o[0]]=true}})});addons.forEach(function(a){if(selected.indexOf(a[0])===-1&&!seen[a[0]]){items.push([a[0],a[1],a[2],a[3],'Additional equipment']);seen[a[0]]=true}});var existing={};[].slice.call(extraGrid.querySelectorAll('.mbc-extra-pick:checked')).forEach(function(input){existing[input.value]=input.closest('.mbc-extra').querySelector('.mbc-extra-qty').value});extraGrid.innerHTML=items.map(function(item){var checked=Object.prototype.hasOwnProperty.call(existing,item[0]);var show=currentFilter==='all'||currentFilter===item[1];return '<article class="mbc-extra" data-category="'+item[1]+'"'+(show?'':' hidden')+'><img src="'+(item[2]||'https://cdn.shopify.com/s/files/1/0772/2185/5542/files/medicalbazzar-logo.png')+'" alt="'+esc(item[0])+'" loading="lazy"><label class="mbc-extra-main"><input class="mbc-extra-pick" type="checkbox" value="'+esc(item[0])+'"'+(checked?' checked':'')+'><span><b>'+esc(item[0])+'</b><small>'+item[4]+'</small></span></label><div class="mbc-extra-actions">'+(item[3]?'<a class="mbc-link" href="'+item[3]+'" target="_blank" rel="noopener">View</a>':'')+'<select class="mbc-extra-qty" aria-label="Quantity for '+esc(item[0])+'"><option'+(existing[item[0]]==='1'?' selected':'')+'>1</option><option'+(existing[item[0]]==='2'?' selected':'')+'>2</option><option'+(existing[item[0]]==='3'?' selected':'')+'>3</option></select></div></article>'}).join('');extraGrid.querySelectorAll('input,select').forEach(function(el){el.addEventListener('change',update)})}
  function updateCard(card){var select=card.querySelector('.mbc-model');var opt=select.options[select.selectedIndex];var img=card.querySelector('.mbc-media img');var link=card.querySelector('.mbc-link');if(opt.dataset.image){img.src=opt.dataset.image;img.alt=opt.value}link.href=opt.dataset.url||'#';link.hidden=!opt.dataset.url;card.querySelector('.mbc-select-label').lastChild.nodeValue=card.querySelector('.mbc-pick').checked?' Selected':' Add to plan'}
  function coreItems(){return [].slice.call(root.querySelectorAll('.mbc-product')).filter(function(card){return card.querySelector('.mbc-pick').checked}).map(function(card){return{kind:'Core',base:clean(card.dataset.group),name:clean(card.querySelector('.mbc-model').value),qty:clean(card.querySelector('.mbc-qty').value)}})}
  function extraItems(){return [].slice.call(extraGrid.querySelectorAll('.mbc-extra')).filter(function(card){return card.querySelector('.mbc-extra-pick').checked}).map(function(card){return{kind:'Added',name:clean(card.querySelector('.mbc-extra-pick').value),qty:clean(card.querySelector('.mbc-extra-qty').value)}})}
  function update(event){var cards=[].slice.call(root.querySelectorAll('.mbc-product'));cards.forEach(updateCard);if(event&&event.target&&event.target.classList.contains('mbc-model'))renderExtras();var core=coreItems();var extra=extraItems();var typed=clean(other.value);var items=core.concat(extra);count.textContent=items.length+(typed?1:0);summary.innerHTML=items.map(function(item){return '<li><span class="mbc-summary-kind">'+item.kind+'</span>'+esc(item.name)+' — Qty '+item.qty+'</li>'}).join('')+(typed?'<li><span class="mbc-summary-kind">Other request</span>'+esc(typed)+'</li>':'');var coreText=core.map(function(item,i){return(i+1)+'. '+item.base+' | Model: '+item.name+' | Qty '+item.qty}).join('\n');var extraText=extra.map(function(item,i){return(i+1)+'. '+item.name+' | Qty '+item.qty}).join('\n')+(typed?'\nOther requested product: '+typed:'');hidden.value='CORE PRODUCTS & MODELS\n'+(coreText||'None')+'\n\nADDITIONAL PRODUCTS\n'+(extraText||'None');var name=clean(root.querySelector('#mbc-name').value)||'Doctor';var phone=clean(root.querySelector('#mbc-phone').value)||'Not provided';var city=clean(root.querySelector('#mbc-city').value)||'Not provided';var budget=clean(root.querySelector('#mbc-budget').value);var space=clean(root.querySelector('#mbc-space').value);var notes=clean(root.querySelector('#mbc-notes').value);var message='Hello MedicalBazzar, I am '+name+'. I want an Advanced Physiotherapy Clinic Setup quotation.\nWhatsApp: '+phone+'\nCity: '+city+'\nBudget: '+budget+'\nClinic space: '+space+'\n\n'+hidden.value+(notes?'\n\nAdditional requirements: '+notes:'');wa.href='https://wa.me/919718497189?text='+encodeURIComponent(message)}
  renderProducts();renderExtras();root.querySelectorAll('.mbc-product input,.mbc-product select').forEach(function(el){el.addEventListener('change',function(e){update(e);if(e.target.classList.contains('mbc-pick')){renderExtras();update()}})});root.querySelectorAll('.mbc-filter').forEach(function(button){button.addEventListener('click',function(){root.querySelectorAll('.mbc-filter').forEach(function(b){b.classList.remove('is-active')});button.classList.add('is-active');currentFilter=button.dataset.filter;renderExtras();update()})});form.addEventListener('input',update);form.addEventListener('submit',update);wa.addEventListener('click',update);other.addEventListener('input',update);update()
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-clinic-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('mbc-complete');
  if(!root)return;
  var groups=[
    {
      "title": "Combination Therapy",
      "desc": "Choose from selected advanced combination therapy systems.",
      "cat": "electrotherapy",
      "options": [
        [
          "accoStimu Physiotherapy Electrotherapy Machine (Touch Screen) Imported",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/acco-stimu-physiotherapy-electrotherapy-imported_1.jpg?v=1762939036",
          "/products/accostimu-physiotherapy-electrotherapy-machine-touch-screen-imported"
        ],
        [
          "acco-Combi IFT Tens MS (8Pads) + US 1&3 Mhz + Deep Heat (2Pads)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AMP-03CM19-5in1-combo-studio-big-body_918b69bf-ddd8-473c-89e2-a1b02a7df63b.jpg?v=1770382609",
          "/products/acco-combi-ift-tens-ms-8pads-us-1-3-mhz-deep-heat-2pads"
        ],
        [
          "acco 4 in 1 Physio Combo Machine IFT MS TENS US 1Mhz with 8 Pads",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/cm15abs-rk-4.jpg?v=1722518439",
          "/products/acco-4-in-1-physio-combo-machine-ift-ms-tens-us-1mhz-with-8-pads"
        ],
        [
          "acco 6 in 1 Combo (IFT+MS+TENS+Russian+US 1&3Mhz) with Deep Heat Therapy Unit",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/cm19rk1_3Mhz.jpg?v=1714053434",
          "/products/acco-6-in-1-combo-ift-ms-tens-russian-us-1-3mhz-with-deep-heat-therapy-unit"
        ],
        [
          "Sales Person Recommendation",
          "",
          ""
        ]
      ]
    },
    {
      "title": "Ultrasound Therapy",
      "desc": "Select a dedicated ultrasound model for routine clinic treatments.",
      "cat": "electrotherapy",
      "options": [
        [
          "Advance Ultrasound Therapy Machine (1 & 3 Mhz) Touch Screen Imported",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/US03TS02-imported-ultrasound-therapy-touch-screen.jpg?v=1761984918",
          "/products/advance-ultrasound-therapy-machine-1-3-mhz-touch-screen-imported"
        ],
        [
          "acco Advance Ultrasound Therapy Machine 1 & 3 Mhz (3 Modes)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/us26-ultrasound-therapy-1-3-mhz-0.jpg?v=1730191068",
          "/products/acco-advance-ultrasound-therapy-machine-1-3-mhz-3-modes"
        ],
        [
          "acco Ultrasound Therapy Unit (1Mhz LED) ABS Body",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/us11abs-ultrasonic-therapy.jpg?v=1711806240",
          "/products/acco-ultrasound-therapy-unit-1mhz-led-abs-body"
        ],
        [
          "Tapsi Ultrasound Therapy Machine 1 Mhz (CYCLOPS 1 : TPS 501)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/ultrasound-therapy-machine-tapsi.png?v=1697627052",
          "/products/tapsi-ultrasound-therapy-machine-1-mhz-cyclops-1-tps-501"
        ],
        [
          "Sales Person Recommendation",
          "",
          ""
        ]
      ]
    },
    {
      "title": "Diathermy Machine",
      "desc": "Choose shortwave or microwave diathermy according to your treatment plan.",
      "cat": "electrotherapy",
      "options": [
        [
          "acco Shortwave Diathermy (500W) Solid State(Cont.&pulse)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Sd08-solid-state-swd-diathermy.jpg?v=1758613258",
          "/products/shortwave-diathermy-500w-solid-statecont-pulse"
        ],
        [
          "acco Shortwave Diathermy (500W) with Valve (Floor Model)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Sw05-1-121-1.jpg?v=1725015347",
          "/products/acco-shortwave-diathermy-500w-with-valve-floor-model"
        ],
        [
          "acco Microwave Diathermy Machine (Table Model- Touch Screen)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MD03-microwave-diathermy-touch-screen.jpg?v=1758616746",
          "/products/acco-microwave-diathermy-machine-table-model-touch-screen"
        ],
        [
          "Sales Person Recommendation",
          "",
          ""
        ]
      ]
    },
    {
      "title": "Traction Machine",
      "desc": "Choose a cervical and lumbar traction system for your clinic.",
      "cat": "traction",
      "options": [
        [
          "acco Cervical & Lumber Traction Unit(LCD Based)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TR01-1_1658ad87-d3c2-4cc6-b36a-d1d3e5420fce.jpg?v=1719224337",
          "/products/acco-cervical-lumber-traction-unitlcd-based"
        ],
        [
          "acco Lumber & Cervical Traction Unit (Manual)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TR05.jpg?v=1710932676",
          "/products/acco-cervical-lumber-traction-unit-manual"
        ],
        [
          "acco Traction Machine (Digital) Lumber and Cervical",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/20230426_171357.jpg?v=1687461533",
          "/products/acco-traction-machine-digital-lumber-and-cervical"
        ],
        [
          "Sales Person Recommendation",
          "",
          ""
        ]
      ]
    },
    {
      "title": "Traction Bed",
      "desc": "Choose a 3-fold, 4-fold or hi-low traction table.",
      "cat": "traction",
      "options": [
        [
          "acco Traction Bed(4folds)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TR04-traction-bed.jpg?v=1741334951",
          "/products/traction-bed4folds"
        ],
        [
          "Traction Bed (3 Fold)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/31gSuCycdXL.jpg?v=1687954979",
          "/products/traction-bed-3-fold"
        ],
        [
          "acco Traction Bed 4folds with box",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TR04A-traction-bed-with-box.jpg?v=1741335485",
          "/products/acco-traction-bed-4folds-with-box"
        ],
        [
          "acco Hi-Low Traction Bed 4folds",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TRACTION-BED-4FOLD_1.jpg?v=1771932614",
          "/products/acco-hi-low-traction-bed-4folds-with-wheels"
        ],
        [
          "Sales Person Recommendation",
          "",
          ""
        ]
      ]
    },
    {
      "title": "Treatment Couch",
      "desc": "Select practical treatment furniture for examination and therapy.",
      "cat": "furniture",
      "options": [
        [
          "acco Wooden Examination Treatment Couch / Plinth",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TrewatmentCouchWooden2Section.jpg?v=1689064944",
          "/products/wooden-examination-treatment-couch-plinth"
        ],
        [
          "Portable Massage Table(Folding, Briefcase Type) 2Fold",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/portable-massage-tabel-2fold.jpg?v=1687959023",
          "/products/portable-massage-tablefolding-briefcase-type-2fold"
        ],
        [
          "acco High Low Treatment Couch  3 Section",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AMP-03TC06-High-low-treatment-couch-3section.jpg?v=1768907663",
          "/products/acco-treatment-couch-cum-examination-couch-3-section"
        ],
        [
          "Sales Person Recommendation",
          "",
          ""
        ]
      ]
    },
    {
      "title": "Exercise & Rehab",
      "desc": "Choose a key exercise unit for mobility, strength and joint rehabilitation.",
      "cat": "exercise",
      "options": [
        [
          "acco Axial Shoulder Wheel",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AxailShoulderWheel.jpg?v=1685610226",
          "/products/acco-axail-shoulder-wheel"
        ],
        [
          "Shoulder Wheel Physiotherapy Exerciser 360 deg (Wall Mounting)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/ShoulderWheel.jpg?v=1685615295",
          "/products/shoulder-wheel-physiotherapy-exerciser-360-deg-wall-mounting"
        ],
        [
          "Mini Exercise Bike with Digital Meter and Resistance",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/pedo-cycle-01copy.jpg?v=1685616541",
          "/products/mini-exercise-bike-with-digital-meter-and-resistance"
        ],
        [
          "acco Ankle Exerciser",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AnkleExerciser-1copy.jpg?v=1685616220",
          "/products/acco-ankle-exerciser"
        ],
        [
          "Sales Person Recommendation",
          "",
          ""
        ]
      ]
    },
    {
      "title": "Heat Therapy",
      "desc": "Select moist heat, wax bath or infrared therapy equipment.",
      "cat": "traction",
      "options": [
        [
          "Acco Hydrocollator With 4Pack | Moist Heat Therapy",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/hydrocollator-4pack-moist-heat.jpg?v=1726220007",
          "/products/acco-hydrocollator-with-4pack-moist-heat-therapy"
        ],
        [
          "acco Wax Bath Unit",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Wax-Bath-Mini.jpg?v=1686054641",
          "/products/acco-wax-bath-unit-extra-small?variant=45445322342710"
        ],
        [
          "acco INFRA-RED LAMP (Floor model)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Infrared-Floor-Model.jpg?v=1686053458",
          "/products/infra-red-lamp-floor-model"
        ],
        [
          "Sales Person Recommendation",
          "",
          ""
        ]
      ]
    },
    {
      "title": "CPM Machine",
      "desc": "Select knee, elbow or shoulder continuous passive motion equipment.",
      "cat": "traction",
      "options": [
        [
          "acco Knee CPM Unit for Physiotherapy",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/knee-cpm-machine.jpg?v=1687959530",
          "/products/acco-knee-cpm-unit-for-physiotherapy"
        ],
        [
          "acco Knee CPM Unit for Physiotherapy (Digital LCD Display)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/cp03-knee-cpm-machine-1.jpg?v=1703496693",
          "/products/acco-knee-cpm-unit-for-physiotherapy-digital-lcd-display"
        ],
        [
          "Imported Elbow CPM Machine - Elbow Rehab Trainer",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/cp06-elbow-cpm-machine-imported_1.jpg?v=1778497531",
          "/products/imported-elbow-cpm-machine"
        ],
        [
          "acco Elbow & Shoulder CPM Machine",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/elbow-cpm-machine.jpg?v=1703495156",
          "/products/acco-elbow-shoulder-cpm-machine"
        ],
        [
          "Sales Person Recommendation",
          "",
          ""
        ]
      ]
    },
    {
      "title": "Trolley",
      "desc": "Keep physiotherapy equipment organized and mobile.",
      "cat": "furniture",
      "options": [
        [
          "acco Z Trolley For Electrotherapy 3 Shelve (Heavy Duty)",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TE21z-z-trolley.jpg?v=1712064759",
          "/products/acco-z-trolley-for-electrotherapy-3-shelve-heavy-duty"
        ],
        [
          "Imp Trolley For Physiotherapy Machine",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AMP-03TE21-IMP1-imported-trolley-physiotherapy_6.jpg?v=1769170920",
          "/products/imp-trolley-for-physiotherapy-machine"
        ],
        [
          "acco Trolley For Electrotherapy 1 Shelve",
          "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/electrotherapy-trolley-1.jpg?v=1702382118",
          "/products/acco-trolley-for-electrotherapy-1-shelve"
        ],
        [
          "Sales Person Recommendation",
          "",
          ""
        ]
      ]
    }
  ];
  var addons=[
    [
      "acco 6 Channel Tens Machine Digital with Auto mode",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TN07.jpg?v=1704704628",
      "/products/copy-of-acco-6-channel-tens-machine-digital-with-auto-mode"
    ],
    [
      "acco acco Tens Unit (4Channel, LCD, 10Pre Prg.)",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TN03D.jpg?v=1710940597",
      "/products/acco-acco-tens-unit-4channel-lcd-10pre-prg"
    ],
    [
      "acco Tens Machine (with 3 Hrs Battery Backup & Touch Buttons)",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/nice-pulse-4ch-tens1.jpg?v=1703164233",
      "/products/acco-tens-machine-with-3-hrs-battery-backup-touch-buttons"
    ],
    [
      "acco Heavy Duty Muscle Stimulator(Diagnostic)",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MS11-MUSCLE-STIMULATOR_3_cf219197-fd8f-4d99-9284-29f09182bd86.jpg?v=1729941004",
      "/products/acco-heavy-duty-muscle-stimulator-diagnostic"
    ],
    [
      "acco Muscle Stimulator with Tens Machine (Computerized)",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MS03.jpg?v=1707225627",
      "/products/acco-muscle-stimulator-with-tens-machine-computerized"
    ],
    [
      "acco IFT MS TENS Russian 200 Programs",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/IRMT-200IFT-MS-TENS-RUSSIAN200Prg.-main.jpg?v=1734092478",
      "/products/acco-ift-ms-tens-russian-200-programs"
    ],
    [
      "acco 4 in 1 Physiotherapy Combo IFT MS TENS(125Prg) + US 1Mhz (50Prg)",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/DCM15-50.jpg?v=1717404272",
      "/products/acco-4-in-1-physiotherapy-combo-ift-ms-tens125prg-us-1mhz-50prg"
    ],
    [
      "acco 4 in 1 Physio Combo Machine IFT MS TENS US 1Mhz with 8 Pads",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/cm15abs-rk-4.jpg?v=1722518439",
      "/products/acco-4-in-1-physio-combo-machine-ift-ms-tens-us-1mhz-with-8-pads"
    ],
    [
      "acco Ultrasound Therapy 1 Mhz with 4 Channel Tens Machine",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20230701_172312.png?v=1689402635",
      "/products/acco-ultrasound-therapy-1-mhz-with-4-channel-tens-machine"
    ],
    [
      "acco Advance 5in1 COMBO (IFT+MS+TENS+US) with Deep Heat Therapy Unit",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20230921_223003.png?v=1695639971",
      "/products/acco-advance-5in1-combo-ift-ms-tens-us-with-deep-heat-therapy-unit"
    ],
    [
      "acco 7 in 1 COMBO (IFT+MS+TENS+Rus+US 1& 3Mhz) + Laser Therapy with Deep Heat Therapy Unit",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/cm27-ift-ms-tens-us-laser-deep-heat.jpg?v=1716366886",
      "/products/acco-6-in-1-combo-ift-ms-tens-us-1-3mhz-laser-therapy-with-deep-heat-therapy-unit"
    ],
    [
      "acco Bemolaser-3B Laser Therapy Machine",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/la14-bemolaser-therapy-1.jpg?v=1739361797",
      "/products/acco-bemolaser-3b-laser-therapy-machine"
    ],
    [
      "acco Advance Laser Therapy Unit (Hot & Cold) with 2 Probes",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20230817_090503.png?v=1692276630",
      "/products/acco-advance-laser-therapy-unit-hot-cold-with-2-probes-la05"
    ],
    [
      "acco Laser Therapy Unit (Power:100mw) Floor Model",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/acco_20231107_135904_0000.png?v=1699346798",
      "/products/acco-laser-therapy-unit-power-100mw-floor-model"
    ],
    [
      "acco Portable Shockwave Therapy Machine- Touch Screen",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/shk-01-shockwave-therapy-machine-2.jpg?v=1715339258",
      "/products/acco-portable-shockwave-therapy-machine-touch-screen"
    ],
    [
      "acco Shockwave Therapy Machine (Table Model)",
      "electrotherapy",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/shk03-shockwave-therapy-1.jpg?v=1711794139",
      "/products/acco-shockwave-therapy-machine-table-model"
    ],
    [
      "acco Therapy Putty (Pack of 100grm)",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PuttySet_5ab0ad6a-c40e-43a3-b3c0-09afe0f5d320.jpg?v=1685610822",
      "/products/acco-therapy-putty-pack-of-100grm-1"
    ],
    [
      "Acco Abduction Shoulder Ladder",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/ShoulderLadder1.jpg?v=1685610069",
      "/products/acco-abduction-shoulder-ladder"
    ],
    [
      "Resistance Loop Exercise Bands (Set Of 5)",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20231122_183219.png?v=1700658635",
      "/products/resistance-loop-exercise-bands"
    ],
    [
      "acco Grip and Finger Exerciser (with Metal base)",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/GripExerciserMetal-1copy.jpg?v=1685610374",
      "/products/acco-grip-and-finger-exerciser-with-metal-base"
    ],
    [
      "acco Exercise Bands / Gym Bands (Set of 5)",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/20231113_162803_0000.png?v=1699875553",
      "/products/acco-exercise-bands-gym-bands-set-of-5"
    ],
    [
      "Shoulder Wheel Physiotherapy Exerciser 360 deg (Wall Mounting)",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/ShoulderWheel.jpg?v=1685615295",
      "/products/shoulder-wheel-physiotherapy-exerciser-360-deg-wall-mounting"
    ],
    [
      "acco Heel Exerciser",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/HeelExerciser-1copy.jpg?v=1685616332",
      "/products/acco-heel-exerciser"
    ],
    [
      "Acco Wrist & Ankle Weight Cuff",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/WeightCuff.jpg?v=1685619555",
      "/products/acco-wrist-ankle-weight-cuff"
    ],
    [
      "Exercise Ball / Physio Gym Ball",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Gym-ball-4.jpg?v=1705149009",
      "/products/exercise-ball-physio-gym-ball"
    ],
    [
      "Power web Hand and finger exerciser Size 14\"",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/power-web-1.jpg?v=1685611596",
      "/products/power-web-hand-and-finger-exerciser-size-14"
    ],
    [
      "TheraBand Flex Bar (Resistance Bar)",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TherabandFlexbar-3.jpg?v=1697279507",
      "/products/theraband-flex-bar-resistance-bar"
    ],
    [
      "Electric Mini Exercise Bike (for Hand and Legs) with Leg Support",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/electric-pedo-cycle.jpg?v=1697879532",
      "/products/electric-mini-exercise-bike-for-hand-and-legs-with-leg-support"
    ],
    [
      "acco Quadricep Table cum Chair (with weights)",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/quardicep-tabel.jpg?v=1704530010",
      "/products/acco-quadricep-table-cum-chair-with-weights"
    ],
    [
      "Automatic Rehab Trainer - Exercise Bike (Arm and Legs)",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/automatic-rehab-trainer-01.jpg?v=1708687362",
      "/products/automatic-rehab-trainer-exercise-bike-arm-and-legs"
    ],
    [
      "acco Vinyl Dumbbell (0.5 to 5Kg)",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/EX20A-dumblle-5.jpg?v=1720266980",
      "/products/acco-vinyl-dumbbell-0-5-to-5kg-with-stand"
    ],
    [
      "Bosu Ball (60Cm/48cm) with Tubing",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Bosu-Ball.jpg?v=1706528953",
      "/products/bosu-ball-60cm-with-tubing"
    ],
    [
      "Upright Air Bike Exercise Static Cycle  - with Movable Handle",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/air-bike-movable-handle.jpg?v=1733483192",
      "/products/upright-air-bike-exercise-static-cycle-with-movable-handle"
    ],
    [
      "Foam Balance Pad",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/foam-balance-pad.jpg?v=1744802513",
      "/products/foam-balance-pad"
    ],
    [
      "Aqua Bags - Weighted water bags",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/aqua-water-bags-weight-bags_a59dbf41-da61-486e-b4e0-fe748a220fed.jpg?v=1777888901",
      "/products/aqua-bags-weighted-water-bags"
    ],
    [
      "acco Medicine Ball (Rubber) (1 to 5Kg)",
      "exercise",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/medicine-ball.jpg?v=1715688813",
      "/products/acco-medicine-ball-rubber"
    ],
    [
      "Chest Massager For Physiotherapy- Thrive Massager",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MA01-thrive-massager.jpg?v=1705131459",
      "/products/chest-massager-for-physiotherapy"
    ],
    [
      "acco Robotic Hand Rehabilitation Gloves MB10",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/robotihand-rehablitation-glove-mb10.jpg?v=1746699847",
      "/products/acco-robotic-hand-rehabilitation-gloves-mb10"
    ],
    [
      "Dry Needles- Acupuncture Needles",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/acupuncture-needles.jpg?v=1779880926",
      "/products/dry-needles-acupuncture-needles"
    ],
    [
      "G5 Massage Machine with 5 Attachments (Floor Model)",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/310DsiiU48L.jpg?v=1697266578",
      "/products/g5-massage-machine-with-5-attachments"
    ],
    [
      "T max Kinesiology Sports Tape (Waterproof, 5mtr x 5cm)",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/tmax-kinesiology-tape-cotton.jpg?v=1726657363",
      "/products/t-max-kinesiology-sports-tape-waterproof-5mtr-x-5cm"
    ],
    [
      "acco Foam Roller ( L13\" x Dia 5.5\")",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/fr01-foam-roller.jpg?v=1713616525",
      "/products/acco-foam-roller-l13-x-dia-5-7"
    ],
    [
      "DVT Compression Therapy Machine with 2 Legs Cuff",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TE05B.jpg?v=1703836307",
      "/products/dvt-compression-therapy-machine-with-2-legs-cuff"
    ],
    [
      "acco Tilt table Manual",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/tilt-table-3.jpg?v=1721646348",
      "/products/acco-tilt-table-manual"
    ],
    [
      "Imported IASTM TOOLS for physiotherapy -Graston tool",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/IASTM-imported-1.jpg?v=1707904543",
      "/products/imported-iastm-tools-for-physiotherapy-graston-tool"
    ],
    [
      "acco Parallel Walking Bar with Platform",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/EX81-parallel-walking-bar.jpg?v=1760175083",
      "/products/acco-parallel-walking-bar-with-platform"
    ],
    [
      "Imported Wobble Board (Round) - Balance Board",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Balance-board-wobble-board-plastic.jpg?v=1778492528",
      "/products/imported-wobble-board-round-balance-board"
    ],
    [
      "acco Chiropractic Drop Table (electrical) - 5 Drop",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AMP-03CHI03-hi-low-chiropractic-bed-5drop.jpg?v=1766666883",
      "/products/acco-chiropractic-drop-table-electrical-5-drop"
    ],
    [
      "Ginha Electric Chiropractic Gun -1200N",
      "other",
      "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CHG-1200N-E.jpg?v=1703339227",
      "/products/ginha-electric-chiropractic-gun-1200n"
    ]
  ];
  var products=root.querySelector('#mbc-products');
  var extraGrid=root.querySelector('#mbc-extra-grid');
  var summary=root.querySelector('#mbc-summary-list');
  var count=root.querySelector('#mbc-count');
  var hidden=root.querySelector('#mbc-selected-hidden');
  var other=root.querySelector('#mbc-other');
  var wa=root.querySelector('#mbc-whatsapp');
  var form=root.querySelector('#mbc-form');
  var currentFilter='all';
  function esc(value){return String(value||'').replace(/[&<>'"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]})}
  function clean(value){return String(value||'').replace(/[<>]/g,'').trim()}
  function renderProducts(){products.innerHTML=groups.map(function(group,index){var first=group.options[0];return '<article class="mbc-product" data-group="'+esc(group.title)+'" data-category="'+group.cat+'"><div class="mbc-media"><img src="'+first[1]+'" alt="'+esc(first[0])+'"></div><div class="mbc-copy"><h3>'+esc(group.title)+'</h3><p>'+esc(group.desc)+'</p><div class="mbc-model-box"><label for="mbc-model-'+index+'">Change model</label><select class="mbc-model" id="mbc-model-'+index+'">'+group.options.map(function(o){return '<option value="'+esc(o[0])+'" data-image="'+esc(o[1])+'" data-url="'+esc(o[2])+'">'+esc(o[0])+'</option>'}).join('')+'</select></div><a class="mbc-link" href="'+first[2]+'" target="_blank" rel="noopener">View selected product</a><div class="mbc-select-row"><label class="mbc-select-label"><input class="mbc-pick" type="checkbox" checked> Selected</label><select class="mbc-qty" aria-label="Quantity for '+esc(group.title)+'"><option>1</option><option>2</option><option>3</option></select></div></div></article>'}).join('')}
  function selectedCoreNames(){return [].slice.call(root.querySelectorAll('.mbc-product')).filter(function(card){return card.querySelector('.mbc-pick').checked}).map(function(card){return card.querySelector('.mbc-model').value})}
  function renderExtras(){var selected=selectedCoreNames();var items=[];var seen={};groups.forEach(function(group){group.options.forEach(function(o){if(o[0]!=='Sales Person Recommendation'&&selected.indexOf(o[0])===-1&&!seen[o[0]]){items.push([o[0],group.cat,o[1],o[2],'Core alternative']);seen[o[0]]=true}})});addons.forEach(function(a){if(selected.indexOf(a[0])===-1&&!seen[a[0]]){items.push([a[0],a[1],a[2],a[3],'Additional equipment']);seen[a[0]]=true}});var existing={};[].slice.call(extraGrid.querySelectorAll('.mbc-extra-pick:checked')).forEach(function(input){existing[input.value]=input.closest('.mbc-extra').querySelector('.mbc-extra-qty').value});extraGrid.innerHTML=items.map(function(item){var checked=Object.prototype.hasOwnProperty.call(existing,item[0]);var show=currentFilter==='all'||currentFilter===item[1];return '<article class="mbc-extra" data-category="'+item[1]+'"'+(show?'':' hidden')+'><img src="'+(item[2]||'https://cdn.shopify.com/s/files/1/0772/2185/5542/files/medicalbazzar-logo.png')+'" alt="'+esc(item[0])+'" loading="lazy"><label class="mbc-extra-main"><input class="mbc-extra-pick" type="checkbox" value="'+esc(item[0])+'"'+(checked?' checked':'')+'><span><b>'+esc(item[0])+'</b><small>'+item[4]+'</small></span></label><div class="mbc-extra-actions">'+(item[3]?'<a class="mbc-link" href="'+item[3]+'" target="_blank" rel="noopener">View</a>':'')+'<select class="mbc-extra-qty" aria-label="Quantity for '+esc(item[0])+'"><option'+(existing[item[0]]==='1'?' selected':'')+'>1</option><option'+(existing[item[0]]==='2'?' selected':'')+'>2</option><option'+(existing[item[0]]==='3'?' selected':'')+'>3</option></select></div></article>'}).join('');extraGrid.querySelectorAll('input,select').forEach(function(el){el.addEventListener('change',update)})}
  function updateCard(card){var select=card.querySelector('.mbc-model');var opt=select.options[select.selectedIndex];var img=card.querySelector('.mbc-media img');var link=card.querySelector('.mbc-link');if(opt.dataset.image){img.src=opt.dataset.image;img.alt=opt.value}link.href=opt.dataset.url||'#';link.hidden=!opt.dataset.url;card.querySelector('.mbc-select-label').lastChild.nodeValue=card.querySelector('.mbc-pick').checked?' Selected':' Add to plan'}
  function coreItems(){return [].slice.call(root.querySelectorAll('.mbc-product')).filter(function(card){return card.querySelector('.mbc-pick').checked}).map(function(card){return{kind:'Core',base:clean(card.dataset.group),name:clean(card.querySelector('.mbc-model').value),qty:clean(card.querySelector('.mbc-qty').value)}})}
  function extraItems(){return [].slice.call(extraGrid.querySelectorAll('.mbc-extra')).filter(function(card){return card.querySelector('.mbc-extra-pick').checked}).map(function(card){return{kind:'Added',name:clean(card.querySelector('.mbc-extra-pick').value),qty:clean(card.querySelector('.mbc-extra-qty').value)}})}
  function update(event){var cards=[].slice.call(root.querySelectorAll('.mbc-product'));cards.forEach(updateCard);if(event&&event.target&&event.target.classList.contains('mbc-model'))renderExtras();var core=coreItems();var extra=extraItems();var typed=clean(other.value);var items=core.concat(extra);count.textContent=items.length+(typed?1:0);summary.innerHTML=items.map(function(item){return '<li><span class="mbc-summary-kind">'+item.kind+'</span>'+esc(item.name)+' — Qty '+item.qty+'</li>'}).join('')+(typed?'<li><span class="mbc-summary-kind">Other request</span>'+esc(typed)+'</li>':'');var coreText=core.map(function(item,i){return(i+1)+'. '+item.base+' | Model: '+item.name+' | Qty '+item.qty}).join('\n');var extraText=extra.map(function(item,i){return(i+1)+'. '+item.name+' | Qty '+item.qty}).join('\n')+(typed?'\nOther requested product: '+typed:'');hidden.value='CORE PRODUCTS & MODELS\n'+(coreText||'None')+'\n\nADDITIONAL PRODUCTS\n'+(extraText||'None');var name=clean(root.querySelector('#mbc-name').value)||'Doctor';var phone=clean(root.querySelector('#mbc-phone').value)||'Not provided';var city=clean(root.querySelector('#mbc-city').value)||'Not provided';var budget=clean(root.querySelector('#mbc-budget').value);var space=clean(root.querySelector('#mbc-space').value);var notes=clean(root.querySelector('#mbc-notes').value);var message='Hello MedicalBazzar, I am '+name+'. I want a Complete Physiotherapy Clinic Setup quotation.\nWhatsApp: '+phone+'\nCity: '+city+'\nBudget: '+budget+'\nClinic space: '+space+'\n\n'+hidden.value+(notes?'\n\nAdditional requirements: '+notes:'');wa.href='https://wa.me/919718497189?text='+encodeURIComponent(message)}
  renderProducts();renderExtras();root.querySelectorAll('.mbc-product input,.mbc-product select').forEach(function(el){el.addEventListener('change',function(e){update(e);if(e.target.classList.contains('mbc-pick')){renderExtras();update()}})});root.querySelectorAll('.mbc-filter').forEach(function(button){button.addEventListener('click',function(){root.querySelectorAll('.mbc-filter').forEach(function(b){b.classList.remove('is-active')});button.classList.add('is-active');currentFilter=button.dataset.filter;renderExtras();update()})});form.addEventListener('input',update);form.addEventListener('submit',update);wa.addEventListener('click',update);other.addEventListener('input',update);update()
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["economy-clinic-builder"] && !Shopify.designMode) return;
  try {
    (function(){
  var root=document.getElementById('mb-economy');
  if(!root)return;
  var cards=[].slice.call(root.querySelectorAll('.mb-product'));
  var addons=[].slice.call(root.querySelectorAll('.mb-addon'));
  var count=root.querySelector('#mb-count');
  var list=root.querySelector('#mb-summary-list');
  var hidden=root.querySelector('#mb-selected-hidden');
  var other=root.querySelector('#mb-other-product');
  var form=root.querySelector('#mb-economy-form');
  var wa=root.querySelector('#mb-whatsapp');
  var currentFilter='all';
  var modelImages={"Acco Ultrasound Therapy 1 & 3 MHz":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/us27-ultrasound-therapy-1-3-mhz-0.jpg?v=1730461646","Acco Ultrasound Therapy 1 MHz LED":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/20221216_172925.jpg?v=1685097814","Acco Ultrasound Therapy 1 & 3 MHz LCD - US24":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/20230119_173040.jpg?v=1685097189","Acco Portable Ultrasound Therapy 1 MHz - US15":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/US15.jpg?v=1685097387","Acco Wooden Examination Couch":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TrewatmentCouchWooden2Section.jpg?v=1689064944","Physiotherapy Examination Couch Metal":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MED.EXA.820349430_1690180070389.webp?v=1699595532","Portable Massage Table 2 Fold":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/portable-massage-tabel-2fold.jpg?v=1687959023","Acco 2 Section Treatment Table":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Manan-2-Section-Treatment-couch_1.jpg?v=1753088909","Shoulder Wheel 360° Wall Mounting":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/ShoulderWheel.jpg?v=1685615295","Acco Axial Shoulder Wheel":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AxailShoulderWheel.jpg?v=1685610226","Magnetic Shoulder Exerciser Imported":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/magnetic-shoulder-wheel.jpg?v=1731332292","Acco T Shoulder Pulley Set":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TPulley.jpg?v=1685616057","Acco Wax Bath Unit":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Wax-Bath-Mini.jpg?v=1686054641","Portable Infrared Lamp":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/InfraredLamp1.jpg?v=1686053688","Acco Infra-Red Lamp Floor Model":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Infrared-Floor-Model.jpg?v=1686053458","Infrared Lamp Table Model":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/HC23-infrared_lamp.jpg?v=1754650843","Infrared Lamp Three Bulbs 450W":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/2561-infraredlamp.jpg?v=1704795817","Acco Digital Traction Machine TR02":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/20230426_171357.jpg?v=1687461533","Acco Digital Traction Unit TR02A":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/20230426_171647.jpg?v=1687462141","Acco LCD Traction Unit TR01":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TR01-1_1658ad87-d3c2-4cc6-b36a-d1d3e5420fce.jpg?v=1719224337","Acco Manual Traction Unit TR05":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TR05.jpg?v=1710932676","Tapsi Auto Traction Machine":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/tapsi-traction-machine.jpg?v=1718955754","Traction Bed 3 Fold":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/31gSuCycdXL.jpg?v=1687954979","Acco Traction Bed 4 Fold":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TR04-traction-bed.jpg?v=1741334951","Acco Traction Bed 4 Fold with Box":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TR04A-traction-bed-with-box.jpg?v=1741335485","Acco Hi-Low Traction Bed 4 Fold":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TRACTION-BED-4FOLD_1.jpg?v=1771932614","acco 4 in 1 Physiotherapy Combo IFT MS TENS(125Prg) + US 1Mhz (50Prg)":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/DCM15-50.jpg?v=1717404272","acco COMBO 5 in 1 (IFT+MS+TENS+US) with Deep Heat Therapy Unit- Combo Machine":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CM19-1.jpg?v=1685474981","acco 5 in 1 (IFT+MS+TENS+US) with Deep Heat 2Pads- Combo Machine":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CM19A-ift-ms-ten-us-deepheat.jpg?v=1739873445","acco Manual IFT Tens MS Physiotherapy Combo":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/acco-ift-ms-tens-combo_3.jpg?v=1784890915","acco Ultrasound Therapy Machine 1& 3 Mhz, LCD Display - US24":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/20230119_173040.jpg?v=1685097189","acco Ultrasonic Machine 1 Mhz Digital":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/US11-8.jpg?v=1685020156","acco Advance Ultrasound Therapy Machine 1 & 3 Mhz (3 Modes)":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/us26-ultrasound-therapy-1-3-mhz-0.jpg?v=1730191068","acco Ultrasound Therapy Machine 1 Mhz LED":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/20221216_172925.jpg?v=1685097814","acco Wooden Examination Treatment Couch / Plinth":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TrewatmentCouchWooden2Section.jpg?v=1689064944","Physiotherapy Examination Treatment Couch (Metal)":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MED.EXA.820349430_1690180070389.webp?v=1699595532","Portable Massage Table(Folding, Briefcase Type) 2Fold":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/portable-massage-tabel-2fold.jpg?v=1687959023","acco Trolley For Electrotherapy 1 Shelve":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/electrotherapy-trolley-1.jpg?v=1702382118","acco Z Trolley For Electrotherapy 3 Shelve (Heavy Duty)":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TE21z-z-trolley.jpg?v=1712064759","acco T Shoulder Pulley Set (Wall Mounting)":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TPulley.jpg?v=1685616057","acco Axail Shoulder Wheel":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AxailShoulderWheel.jpg?v=1685610226","acco Mini Exercise Bike (with Digital Meter and Resistance)":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/pedo-cycle-01copy.jpg?v=1685616541","acco Ankle Exerciser":"https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AnkleExerciser-1copy.jpg?v=1685616220"};
  function clean(value){return String(value||'').replace(/[<>]/g,'').trim()}
  function syncCardImage(card){
    var select=card.querySelector('.mb-model');
    var image=card.querySelector('.mb-product-media img');
    if(!select||!image)return;
    if(!image.dataset.originalSrc)image.dataset.originalSrc=image.currentSrc||image.src;
    var next=modelImages[select.value]||image.dataset.originalSrc;
    if(image.src!==next){
      image.src=next;
      image.alt=select.value==='Sales team recommendation'?clean(card.querySelector('h3').textContent):select.value;
    }
  }
  function coreItems(){
    return cards.filter(function(card){return card.querySelector('.mb-pick').checked}).map(function(card){
      return{kind:'Core',base:clean(card.querySelector('h3').textContent),name:clean(card.querySelector('.mb-model').value),qty:clean(card.querySelector('.mb-qty').value)}
    })
  }
  function addonItems(){
    return addons.filter(function(card){return card.querySelector('.mb-addon-pick').checked}).map(function(card){
      return{kind:'Added',name:clean(card.getAttribute('data-name')),qty:clean(card.querySelector('.mb-addon-qty').value)}
    })
  }
  function applyAddonVisibility(){
    var selectedCore=cards.filter(function(card){return card.querySelector('.mb-pick').checked}).map(function(card){return clean(card.querySelector('.mb-model').value)});
    addons.forEach(function(card){
      var coreValue=clean(card.getAttribute('data-core-value'));
      var isSelectedCore=coreValue&&selectedCore.indexOf(coreValue)!==-1;
      var categoryMatches=currentFilter==='all'||card.getAttribute('data-category')===currentFilter;
      if(isSelectedCore)card.querySelector('.mb-addon-pick').checked=false;
      card.hidden=isSelectedCore||!categoryMatches;
    })
  }
  function update(){
    cards.forEach(syncCardImage);
    applyAddonVisibility();
    var core=coreItems();
    var extra=addonItems();
    var typed=clean(other.value);
    var items=core.concat(extra);
    count.textContent=items.length+(typed?1:0);
    list.innerHTML=items.map(function(item){return'<li><span class="mb-summary-kind">'+item.kind+'</span>'+item.name+' — Qty '+item.qty+'</li>'}).join('')+(typed?'<li><span class="mb-summary-kind">Other request</span>'+typed+'</li>':'');
    var coreSummary=core.map(function(item,index){return(index+1)+'. '+item.base+' | Model: '+item.name+' | Qty '+item.qty}).join('\n');
    var addonSummary=extra.map(function(item,index){return(index+1)+'. '+item.name+' | Qty '+item.qty}).join('\n')+(typed?'\nOther requested product: '+typed:'');
    hidden.value='CORE PRODUCTS & MODELS\n'+(coreSummary||'None')+'\n\nADDITIONAL PRODUCTS\n'+(addonSummary||'None');
    cards.forEach(function(card){card.querySelector('.mb-select-label').lastChild.nodeValue=card.querySelector('.mb-pick').checked?' Selected':' Add to plan'});
    var name=clean(root.querySelector('#mb-name').value)||'Doctor';
    var phone=clean(root.querySelector('#mb-phone').value)||'Not provided';
    var city=clean(root.querySelector('#mb-city').value)||'Not provided';
    var budget=clean(root.querySelector('#mb-budget').value);
    var space=clean(root.querySelector('#mb-space').value);
    var notes=clean(root.querySelector('#mb-notes').value);
    var message='Hello MedicalBazzar, I am '+name+'. I want an Economy Physiotherapy Clinic Setup quotation.\nWhatsApp: '+phone+'\nCity: '+city+'\nBudget: '+budget+'\nClinic space: '+space+'\n\n'+hidden.value+(notes?'\n\nAdditional requirements: '+notes:'');
    wa.setAttribute('href','https://wa.me/919718497189?text='+encodeURIComponent(message))
  }
  Object.keys(modelImages).forEach(function(key){var preload=new Image();preload.src=modelImages[key]});
  cards.forEach(function(card){card.addEventListener('change',update);syncCardImage(card)});
  addons.forEach(function(card){card.addEventListener('change',update)});
  root.querySelectorAll('.mb-filter').forEach(function(button){
    button.addEventListener('click',function(){
      root.querySelectorAll('.mb-filter').forEach(function(item){item.classList.remove('is-active')});
      button.classList.add('is-active');
      currentFilter=button.getAttribute('data-filter');
      applyAddonVisibility()
    })
  });
  form.addEventListener('input',update);
  form.addEventListener('submit',update);
  wa.addEventListener('click',function(){update()});
  other.addEventListener('input',update);
  update()
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portable-clinic-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('mbc-portable');
  if(!root)return;
  var groups=[
  {
    "title": "Portable Combination Therapy",
    "desc": "Choose a compact multi-modality unit for home visits.",
    "cat": "electrotherapy",
    "options": [
      [
        "Acco Mini Combo IFT TENS MS Rus (Imported)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/AMP-05MCM4-1-mini-combo-ift-tens-ms-rus.jpg?v=1720702810",
        "/products/acco-mini-combo-ift-tens-ms-rus-imported"
      ],
      [
        "Acco Mini Combo IFT TENS MS",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20230718_234430.png?v=1689707865",
        "/products/acco-mini-combo-ift-tens-ms-cmspro16"
      ],
      [
        "Acco Combo IFT TENS MS Digital 3 in 1",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20230720_172656.png?v=1690025583",
        "/products/acco-combo-ift-tens-ms-digital-3-in-1-cm-powerstim109"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Portable TENS & Muscle Stimulation",
    "desc": "Choose a lightweight pain-relief and muscle-stimulation unit.",
    "cat": "electrotherapy",
    "options": [
      [
        "Pocket TENS Machine & EMS Muscle Stimulator – 4 Channel",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/mcm2-1-pocket-tens-ems-machine.jpg?v=1788435273",
        "/products/besmed-pocket-tens-machine-2-ch-battery-operated"
      ],
      [
        "acco Tens Machine 2 Ch with Muscle Stimulator",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20230714_174118.png?v=1689666314",
        "/products/acco-tens-machine-2-ch-with-muscle-stimulator"
      ],
      [
        "acco 2 in 1 MS+TENS 2Ch with Timer Physiotherapy Combo Machine",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/71NySjGBv1L._SL1500.jpg?v=1685474055",
        "/products/acco-2-in-1-ms-tens-2ch-with-timer-physiotherapy-combo-machine"
      ],
      [
        "acco COMBO (TENS & Muscle Stimulator) MINI",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CM05.jpg?v=1685452976",
        "/products/acco-combo-tens-muscle-stimulator-mini"
      ],
      [
        "acco MS Tens Physiotherapy Combo Machine 2 in 1 with Timer",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CM05D-1.jpg?v=1685454396",
        "/products/acco-ms-tens-physiotherapy-combo-machine-2-in-1-with-timer"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Portable Ultrasound Therapy",
    "desc": "Select a compact ultrasound therapy unit suitable for travel.",
    "cat": "electrotherapy",
    "options": [
      [
        "Handheld Ultrasound Therapy Machine 1Mhz GB-818",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/gb818-portable-ultrasound-therapy.jpg?v=1759492190",
        "/products/handheld-ultrasound-therapy-machine-1mhz-gb-818"
      ],
      [
        "acco Ultrasound Therapy Machine 1 Mhz LED",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/20221216_172925.jpg?v=1685097814",
        "/products/acco-ultrasound-therapy-machine-1-mhz-led"
      ],
      [
        "acco Mini Ultrasound Therapy Machine (1MHz)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/US15A-4copy.jpg?v=1685259834",
        "/products/mini-physio-ultrasound-therapy-machine-1mhz"
      ],
      [
        "acco Portable Ultrasound Therapy Machine 1 Mhz - US15",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/US15.jpg?v=1685097387",
        "/products/acco-portable-ultrasound-therapy-machine-1-mhz-us15"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Portable Laser Therapy",
    "desc": "Choose a handheld or portable laser therapy device.",
    "cat": "electrotherapy",
    "options": [
      [
        "Handheld Laser Therapy Device (650nm 150mW)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/la09-portable-laser.jpg?v=1712147431",
        "/products/handheld-laser-therapy-device-650nm-150mw"
      ],
      [
        "Portable Laser Therapy Machine (808nm)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/laser.jpg?v=1735044016",
        "/products/portable-laser-therapy-machine-808nm"
      ],
      [
        "Tapsi Laser with Micro Current (Portable)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/LA07-tapsi-laser-with-micro-current_1.jpg?v=1744968956",
        "/products/tapsi-laser-with-micro-current-portable"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Heat & Cold Therapy",
    "desc": "Select a portable heat, cold or compression therapy option.",
    "cat": "recovery",
    "options": [
      [
        "Therapy Plus Hot & Cold Gel Pack (Microwaveable) with Towel Cover",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/HotColdPackImported.jpg?v=1686051666",
        "/products/therapy-plus-hot-cold-gel-pack-microwaveable-with-towel-cover"
      ],
      [
        "acco Steam Pack Moist heat packs- Hydrocollator Pack",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MoistHeatPack.jpg?v=1686051169",
        "/products/acco-steam-pack-moist-heat-packs-hydrocollator-pack"
      ],
      [
        "Knee Cold Compression Wrap (Manual)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/knee-cold-compression-wrap-11-1.png?v=1757763569",
        "/products/knee-cold-compression-wrap-manual"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Portable Treatment Couch",
    "desc": "Choose a foldable treatment table for professional home visits.",
    "cat": "furniture",
    "options": [
      [
        "Portable Massage Table(Folding, Briefcase Type) 2Fold",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/portable-massage-tabel-2fold.jpg?v=1687959023",
        "/products/portable-massage-tablefolding-briefcase-type-2fold"
      ],
      [
        "Professional Portable Spa Foldable Wooden Massage Table With Carry Bag - 3 Fold (Premium)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/portable-massage-tabel-3fold-1.jpg?v=1687958949",
        "/products/professional-portable-spa-foldable-wooden-massage-table-with-carry-bag-3-fold-premium"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  },
  {
    "title": "Portable Exercise & Rehab",
    "desc": "Choose a versatile exercise or rehabilitation essential.",
    "cat": "exercise",
    "options": [
      [
        "Aqua Bags - Weighted water bags",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/aqua-water-bags-weight-bags_a59dbf41-da61-486e-b4e0-fe748a220fed.jpg?v=1777888901",
        "/products/aqua-bags-weighted-water-bags"
      ],
      [
        "Acco Wrist & Ankle Weight Cuff",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/WeightCuff.jpg?v=1685619555",
        "/products/acco-wrist-ankle-weight-cuff"
      ],
      [
        "acco Shoulder Pulley Kit (Over Door Model)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20231006_160606.png?v=1696592026",
        "/products/acco-shoulder-pulley-kit-over-door-model"
      ],
      [
        "Resistance Loop Exercise Bands (Set Of 5)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20231122_183219.png?v=1700658635",
        "/products/resistance-loop-exercise-bands"
      ],
      [
        "acco Therapy Putty (Pack of 100grm)",
        "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PuttySet_5ab0ad6a-c40e-43a3-b3c0-09afe0f5d320.jpg?v=1685610822",
        "/products/acco-therapy-putty-pack-of-100grm-1"
      ],
      [
        "Sales Person Recommendation",
        "",
        ""
      ]
    ]
  }
];
  var addons=[
  [
    "acco Mini Tens Machine 2ch",
    "electrotherapy",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TN01-ABS-1.jpg?v=1685274172",
    "/products/acco-mini-tens-machine-2ch"
  ],
  [
    "acco Tens Machine 2 Channel LCD 10 Program",
    "electrotherapy",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TN01A-1.jpg?v=1685274800",
    "/products/acco-tens-machine-2-channel-lcd-10-program"
  ],
  [
    "Pocket Tens - Ems Machine 2 Ch (Battery Operated)",
    "electrotherapy",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/tn02b-ACCO-pocket-tans-machine_2.jpg?v=1758021725",
    "/products/blueidea-pocket-tens-ems-machine-2-ch-battery-operated"
  ],
  [
    "acco 4 in 1 Physiotherapy Combo IFT MS TENS(125Prg) + US 1Mhz (50Prg)",
    "electrotherapy",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/DCM15-50.jpg?v=1717404272",
    "/products/acco-4-in-1-physiotherapy-combo-ift-ms-tens125prg-us-1mhz-50prg"
  ],
  [
    "acco COMBO 5 in 1 (IFT+MS+TENS+US) with Deep Heat Therapy Unit- Combo Machine",
    "electrotherapy",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CM19-1.jpg?v=1685474981",
    "/products/combo-5-in-1-ift-ms-tens-us-with-deep-heat-therapy-unit-combo-machine"
  ],
  [
    "acco COMBO (Interferential Therapy+Ultrasound Therapy 1Mhz)",
    "electrotherapy",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20230725_174454.png?v=1690369783",
    "/products/combo-interferential-therapy-ultrasound-therapy"
  ],
  [
    "acco Ultrasound Therapy 1 Mhz with 4 Channel Tens Machine",
    "electrotherapy",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/PhotoRoom-20230701_172312.png?v=1689402635",
    "/products/acco-ultrasound-therapy-1-mhz-with-4-channel-tens-machine"
  ],
  [
    "acco TENS+US Physiotherapy Combination Therapy 2 in 1 Combo with timer",
    "electrotherapy",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/CM04copy.jpg?v=1685472296",
    "/products/acco-tens-us-physiotherapy-combination-therapy-2-in-1-combo-with-timer"
  ],
  [
    "acco Deep Heat Therapy Machine (2 Pads)",
    "electrotherapy",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/sl17B-deep-heat.jpg?v=1709285349",
    "/products/acco-deep-heat-therapy-machine-2-pads"
  ],
  [
    "acco Grip and Finger Exerciser (with Metal base)",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/GripExerciserMetal-1copy.jpg?v=1685610374",
    "/products/acco-grip-and-finger-exerciser-with-metal-base"
  ],
  [
    "acco Hand exercise Ball - Gel Ball",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Gelball-3.jpg?v=1699344396",
    "/products/acco-hand-exercise-ball-gel-ball"
  ],
  [
    "acco Exercise Bands / Gym Bands (Set of 5)",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/20231113_162803_0000.png?v=1699875553",
    "/products/acco-exercise-bands-gym-bands-set-of-5"
  ],
  [
    "Power web Hand and finger exerciser Size 14\"",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/power-web-1.jpg?v=1685611596",
    "/products/power-web-hand-and-finger-exerciser-size-14"
  ],
  [
    "TheraBand Flex Bar (Resistance Bar)",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TherabandFlexbar-3.jpg?v=1697279507",
    "/products/theraband-flex-bar-resistance-bar"
  ],
  [
    "acco Egg Shape Hand exercise Ball",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/EggShapeBall-1.jpg?v=1773657887",
    "/products/acco-egg-shape-hand-exercise-ball"
  ],
  [
    "Exercise Ball / Physio Gym Ball",
    "exercise",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Gym-ball-4.jpg?v=1705149009",
    "/products/exercise-ball-physio-gym-ball"
  ],
  [
    "Acco Physio Wax - Paraffin Wax",
    "recovery",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Wax-01.jpg?v=1686054210",
    "/products/acco-physio-wax"
  ],
  [
    "acco Orthopedic Electric heating Belt for Back Pain",
    "recovery",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/LHP-Front.jpg?v=1686051887",
    "/products/acco-orthopedic-electric-heating-belt-for-back-pain"
  ],
  [
    "Orthopedic Electric heating Belt for Knee Pain",
    "recovery",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/KHP-Front.jpg?v=1686052064",
    "/products/orthopedic-electric-heating-belt-for-knee-pain"
  ],
  [
    "Shoulder Cold Compression Wrap (Manual)",
    "recovery",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/shoulder-cold-compression-wrap-11.png?v=1757766785",
    "/products/shoulder-cold-compression-wrap-manual"
  ],
  [
    "Back Cold Compression Wrap (Manual)",
    "recovery",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Manual-cold-compression-wrap-back.jpg?v=1748611191",
    "/products/back-cold-compression-wrap-manual"
  ],
  [
    "Ankle Cold Compression Wrap (Manual)",
    "recovery",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Cold-compression-wrap-ankle.png?v=1757761404",
    "/products/ankle-cold-compression-wrap-manual-copy"
  ],
  [
    "acco Handel For Ultrasound Therapy Machine",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/USheadnCable.jpg?v=1693471335",
    "/products/handel-for-ultrasound-therapy-machine"
  ],
  [
    "acco Ultrasound Gel for ECG and Physiotherapy",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Ultrasound-gel-pack-of-3.jpg?v=1687953472",
    "/products/ultrasound-gel-for-ecg-and-physiotherapy"
  ],
  [
    "acco Accessories Of Tens Machine (Wire & Pads)",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Tenswireandpad.jpg?v=1693554022",
    "/products/accessories-of-tens-machine-wire-pads"
  ],
  [
    "Self Adhesive Electrode for Mini Tens and Muscle Stimulator (Set of 4 Pcs)",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/61wUm5c-ROL.jpg?v=1693556258",
    "/products/self-adhesive-electrode-for-mini-tens-and-muscle-stimulator-set-of-4-pcs"
  ],
  [
    "Wire For Imported Electrotherapy - Besmed Tens Wires",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/besmedtenswire.jpg?v=1731062318",
    "/products/wire-for-imported-electrotherapy-besmed-tens-wires"
  ],
  [
    "acco Accessories of Mini Muscle Stimulator | IFT Machine",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/IFTWireandPads.jpg?v=1695817187",
    "/products/acco-accessories-of-mini-muscle-stimulator-ift-machine"
  ],
  [
    "Chest Massager For Physiotherapy- Thrive Massager",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MA01-thrive-massager.jpg?v=1705131459",
    "/products/chest-massager-for-physiotherapy"
  ],
  [
    "acco Mulligan Belts for Physiotherapy - Size: Length:-8ft",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/MulliganBelt.jpg?v=1687518305",
    "/products/acco-mulligan-belts-for-physiotherapy-size-length-8ft"
  ],
  [
    "Hijama Cups for Cupping Therapy",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/hijama-cups-2.jpg?v=1732263835",
    "/products/hijama-cups-for-cupping-therapy"
  ],
  [
    "Hijama Vacuum Cupping Set",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/TE36-Hijama-1.jpg?v=1699532078",
    "/products/hijama-cupping-set"
  ],
  [
    "acco IASTM TOOLS for physiotherapy -Graston tool",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/IASTM-09.jpg?v=1687510461",
    "/products/acco-iastm-tools-for-physiotherapy-graston-tool"
  ],
  [
    "Dry Needles- Acupuncture Needles",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/acupuncture-needles.jpg?v=1779880926",
    "/products/dry-needles-acupuncture-needles"
  ],
  [
    "acco Robotic Hand Rehabilitation Gloves MB10",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/robotihand-rehablitation-glove-mb10.jpg?v=1746699847",
    "/products/acco-robotic-hand-rehabilitation-gloves-mb10"
  ],
  [
    "Kinesiology Sports Tape (5m x 5cm)",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/41vT0QLLrUL.jpg?v=1689253510",
    "/products/kinesiology-sports-tape-5m-x-5cm"
  ],
  [
    "Electric Vacuum Cupping Therapy Set",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/electric-cupping-massager-te41.jpg?v=1709550934",
    "/products/electric-vacuum-cupping-therapy-set-6-gear"
  ],
  [
    "acco Glass Fire Cupping Set of 16 Cups",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/fire-cupping-set.jpg?v=1725526509",
    "/products/acco-glass-fire-cupping-set-of-16-cups"
  ],
  [
    "acco Foam Roller ( L13\" x Dia 5.5\")",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/fr01-foam-roller.jpg?v=1713616525",
    "/products/acco-foam-roller-l13-x-dia-5-7"
  ],
  [
    "Blaze Pod Trainer Kit",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/blaze-pod-trainer-kit-7.jpg?v=1721473245",
    "/products/blaze-pod-trainer-kit"
  ],
  [
    "Imported Wobble Board (Round) - Balance Board",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/Balance-board-wobble-board-plastic.jpg?v=1778492528",
    "/products/imported-wobble-board-round-balance-board"
  ],
  [
    "Manual Chiropractic Gun Adjusting Tool - 400N",
    "consumable",
    "https://cdn.shopify.com/s/files/1/0772/2185/5542/files/41vxBf89pbL.jpg?v=1703337728",
    "/products/manual-chiropractic-gun-adjusting-tool"
  ]
];
  var products=root.querySelector('#mbc-products');
  var extraGrid=root.querySelector('#mbc-extra-grid');
  var summary=root.querySelector('#mbc-summary-list');
  var count=root.querySelector('#mbc-count');
  var hidden=root.querySelector('#mbc-selected-hidden');
  var other=root.querySelector('#mbc-other');
  var wa=root.querySelector('#mbc-whatsapp');
  var form=root.querySelector('#mbc-form');
  var currentFilter='all';
  function esc(value){return String(value||'').replace(/[&<>'"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]})}
  function clean(value){return String(value||'').replace(/[<>]/g,'').trim()}
  function renderProducts(){products.innerHTML=groups.map(function(group,index){var first=group.options[0];return '<article class="mbc-product" data-group="'+esc(group.title)+'" data-category="'+group.cat+'"><div class="mbc-media"><img src="'+first[1]+'" alt="'+esc(first[0])+'"></div><div class="mbc-copy"><h3>'+esc(group.title)+'</h3><p>'+esc(group.desc)+'</p><div class="mbc-model-box"><label for="mbc-model-'+index+'">Change model</label><select class="mbc-model" id="mbc-model-'+index+'">'+group.options.map(function(o){return '<option value="'+esc(o[0])+'" data-image="'+esc(o[1])+'" data-url="'+esc(o[2])+'">'+esc(o[0])+'</option>'}).join('')+'</select></div><a class="mbc-link" href="'+first[2]+'" target="_blank" rel="noopener">View selected product</a><div class="mbc-select-row"><label class="mbc-select-label"><input class="mbc-pick" type="checkbox" checked> Selected</label><select class="mbc-qty" aria-label="Quantity for '+esc(group.title)+'"><option>1</option><option>2</option><option>3</option></select></div></div></article>'}).join('')}
  function selectedCoreNames(){return [].slice.call(root.querySelectorAll('.mbc-product')).filter(function(card){return card.querySelector('.mbc-pick').checked}).map(function(card){return card.querySelector('.mbc-model').value})}
  function renderExtras(){var selected=selectedCoreNames();var items=[];var seen={};groups.forEach(function(group){group.options.forEach(function(o){if(o[0]!=='Sales Person Recommendation'&&selected.indexOf(o[0])===-1&&!seen[o[0]]){items.push([o[0],group.cat,o[1],o[2],'Core alternative']);seen[o[0]]=true}})});addons.forEach(function(a){if(selected.indexOf(a[0])===-1&&!seen[a[0]]){items.push([a[0],a[1],a[2],a[3],'Additional equipment']);seen[a[0]]=true}});var existing={};[].slice.call(extraGrid.querySelectorAll('.mbc-extra-pick:checked')).forEach(function(input){existing[input.value]=input.closest('.mbc-extra').querySelector('.mbc-extra-qty').value});extraGrid.innerHTML=items.map(function(item){var checked=Object.prototype.hasOwnProperty.call(existing,item[0]);var show=currentFilter==='all'||currentFilter===item[1];return '<article class="mbc-extra" data-category="'+item[1]+'"'+(show?'':' hidden')+'><img src="'+(item[2]||'https://cdn.shopify.com/s/files/1/0772/2185/5542/files/medicalbazzar-logo.png')+'" alt="'+esc(item[0])+'" loading="lazy"><label class="mbc-extra-main"><input class="mbc-extra-pick" type="checkbox" value="'+esc(item[0])+'"'+(checked?' checked':'')+'><span><b>'+esc(item[0])+'</b><small>'+item[4]+'</small></span></label><div class="mbc-extra-actions">'+(item[3]?'<a class="mbc-link" href="'+item[3]+'" target="_blank" rel="noopener">View</a>':'')+'<select class="mbc-extra-qty" aria-label="Quantity for '+esc(item[0])+'"><option'+(existing[item[0]]==='1'?' selected':'')+'>1</option><option'+(existing[item[0]]==='2'?' selected':'')+'>2</option><option'+(existing[item[0]]==='3'?' selected':'')+'>3</option></select></div></article>'}).join('');extraGrid.querySelectorAll('input,select').forEach(function(el){el.addEventListener('change',update)})}
  function updateCard(card){var select=card.querySelector('.mbc-model');var opt=select.options[select.selectedIndex];var img=card.querySelector('.mbc-media img');var link=card.querySelector('.mbc-link');img.src=opt.dataset.image||'https://cdn.shopify.com/s/files/1/0772/2185/5542/files/medicalbazzar-logo.png';img.alt=opt.value;link.href=opt.dataset.url||'#';link.hidden=!opt.dataset.url;card.querySelector('.mbc-select-label').lastChild.nodeValue=card.querySelector('.mbc-pick').checked?' Selected':' Add to plan'}
  function coreItems(){return [].slice.call(root.querySelectorAll('.mbc-product')).filter(function(card){return card.querySelector('.mbc-pick').checked}).map(function(card){return{kind:'Core',base:clean(card.dataset.group),name:clean(card.querySelector('.mbc-model').value),qty:clean(card.querySelector('.mbc-qty').value)}})}
  function extraItems(){return [].slice.call(extraGrid.querySelectorAll('.mbc-extra')).filter(function(card){return card.querySelector('.mbc-extra-pick').checked}).map(function(card){return{kind:'Added',name:clean(card.querySelector('.mbc-extra-pick').value),qty:clean(card.querySelector('.mbc-extra-qty').value)}})}
  function update(event){var cards=[].slice.call(root.querySelectorAll('.mbc-product'));cards.forEach(updateCard);if(event&&event.target&&event.target.classList.contains('mbc-model'))renderExtras();var core=coreItems();var extra=extraItems();var typed=clean(other.value);var items=core.concat(extra);count.textContent=items.length+(typed?1:0);summary.innerHTML=items.map(function(item){return '<li><span class="mbc-summary-kind">'+item.kind+'</span>'+esc(item.name)+' — Qty '+item.qty+'</li>'}).join('')+(typed?'<li><span class="mbc-summary-kind">Other request</span>'+esc(typed)+'</li>':'');var coreText=core.map(function(item,i){return(i+1)+'. '+item.base+' | Model: '+item.name+' | Qty '+item.qty}).join('\n');var extraText=extra.map(function(item,i){return(i+1)+'. '+item.name+' | Qty '+item.qty}).join('\n')+(typed?'\nOther requested product: '+typed:'');hidden.value='CORE PRODUCTS & MODELS\n'+(coreText||'None')+'\n\nADDITIONAL PRODUCTS\n'+(extraText||'None');var name=clean(root.querySelector('#mbc-name').value)||'Doctor';var phone=clean(root.querySelector('#mbc-phone').value)||'Not provided';var city=clean(root.querySelector('#mbc-city').value)||'Not provided';var budget=clean(root.querySelector('#mbc-budget').value);var space=clean(root.querySelector('#mbc-space').value);var notes=clean(root.querySelector('#mbc-notes').value);var message='Hello MedicalBazzar, I am '+name+'. I want a Portable Physiotherapy Clinic Setup for Home Visits quotation.\nWhatsApp: '+phone+'\nCity: '+city+'\nBudget: '+budget+'\nClinic space: '+space+'\n\n'+hidden.value+(notes?'\n\nAdditional requirements: '+notes:'');wa.href='https://wa.me/919718497189?text='+encodeURIComponent(message)}
  renderProducts();renderExtras();root.querySelectorAll('.mbc-product input,.mbc-product select').forEach(function(el){el.addEventListener('change',function(e){update(e);if(e.target.classList.contains('mbc-pick')){renderExtras();update()}})});root.querySelectorAll('.mbc-filter').forEach(function(button){button.addEventListener('click',function(){root.querySelectorAll('.mbc-filter').forEach(function(b){b.classList.remove('is-active')});button.classList.add('is-active');currentFilter=button.dataset.filter;renderExtras();update()})});form.addEventListener('input',update);form.addEventListener('submit',update);wa.addEventListener('click',update);other.addEventListener('input',update);update()
})();

  } catch(e) { console.error(e); }
})();
})();
